export default "__VITE_ASSET__8f334ec2__"